import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SITE } from "@/lib/site";

export const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

// `title` / `desc` : surcharges dynamiques (articles NovaTV, fiches projet) —
// à défaut, les libellés i18n `seo.{page}` servent de valeurs par défaut pendant le chargement.
export const Seo = ({ page, image, title: titleOverride, desc: descOverride, noindex }) => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const title = titleOverride || t(`seo.${page}.title`);
    const desc = descOverride || t(`seo.${page}.desc`);
    const img = `${SITE.url}${image || "/images/hero.png"}`;
    // Canonical basé sur le domaine de production, sans query string (tokens ?resume/?lm jamais exposés)
    const canonical = `${SITE.url}${window.location.pathname}`;
    document.title = title;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "NovaImmo");
    setMeta("property", "og:image", img);
    setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:image", img);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
    // Page dormante (ex. Elyon masqué) : noindex explicite.
    // Sinon, page publique : nettoie un éventuel noindex laissé par un contexte privé
    // (admin, /suivi, résultat LifeMatch) lors d'une navigation SPA dans la même session.
    if (noindex) {
      setMeta("name", "robots", "noindex, nofollow");
      // Une page noindex ne doit exposer AUCUN canonical (ni vers elle-même, ni vers une page valide)
      if (link) link.remove();
    } else {
      const robots = document.head.querySelector('meta[name="robots"]');
      if (robots) robots.remove();
    }
  }, [page, image, titleOverride, descOverride, noindex, t, i18n.language]);
  return null;
};
